import { FormControl, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, OutlinedInputProps } from "@mui/material";
import { Input } from "../../../components/Input/input";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { ButtonWraper, GoBackButton } from "../../../components/GoBackButton";
import { theme } from "../../../helpers/theme";
import ClientAddForm from "./ClientAddForm";
import OperatorAddForm from "./OperatorAddForm";
import * as yup from "yup";
import { useFormik } from "formik";
import SubcontractorPick from "./SubcontractorPick";
import ClientPick from "./ClientPick";
import { StyledButton } from "../../../components/Button/button";
import { useMutation } from "@tanstack/react-query";
import { addUser } from "../../../services/users/add";
import { toast, ToastOptions } from "react-toastify";
import { OperatorAddData } from "../../../services/users/add/types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Dayjs } from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl } from "date-fns/locale";
import ClientAddStepper from "./ClientAddStepper";

const OperatorUserAdd = () => {
  const [userType, setUserType] = useState<number>(0);
  const [operator, setOperator] = useState<OperatorAddData | null>();
  // const [clientId, setClientId] = useState<string | null>(null);
  const [subcontractorId, setSubcontractorId] = useState<string | null>();
  const [formValid, setFormValid] = useState<boolean>(false);
  // const [basicUserDataVisible, setBasicUserDataVisible] = useState<boolean>(false);

  const [toDate, setToDate] = useState<Dayjs | Date | string | null >(null);
  const [dateToInvalid, setDateToInvalid] = useState<string | null>(null);

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const AddUserMutation = useMutation(addUser, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", { toastId: "AddSuccessfully", ...settings });
    },
    onError: (err:any) => {
      if (err.response.data.errors_debug[0] === "client already in use") {
        toast.error("Konto dla podanego klienta już istnieje", { toastId: "AddUserFailed", ...settings });
      } else if (err.response.data.errors_debug[0] === "User already exist with login." || err.response.data.errors_debug[0] === "User already exist with login or email") {
        toast.error("Podany login jest już zajęty", { toastId: "AddUserFailed", ...settings });
      }
    }
  });

  const activeValue = (active: Boolean | string) => {
    if (typeof active == "boolean") {
      return active
    } else {
      return active === "true" ? true : false
    }
  }

  const loginRegex = /^[a-zA-Z0-9@!.]+$/;

  const validationSchema = yup.object({
    login: yup
      .string()
      .required("Pole wymagane")
      .matches(loginRegex, "Niepoprawny login")
      .min(3, "Login musi mieć minimum 3 znaki"),
    haslo: yup
      .string()
      .required("Pole wymagane")
      .min(8, "Hasło musi posiadać minimum 8 znaków")
      .max(50, "Hasło musi posiadać maksymalnie 50 znaków")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Hasło musi posiadać posiadać od 8 do 50 znaków, w tym co najmniej: 1 - dużą literę, 1 - małą literę, 1 - cyfrę, 1 - znak specjalny"
      ),
    czy_aktywny: yup
      .string(),
  });

  const formik = useFormik({
    initialValues: {
      login: "",
      haslo: "",
      czy_aktywny: "false",
      // aktywny_data_do: null,
      operator: {
        imie: "",
        nazwisko: "",
        email: "",
        telefon: "",
      },
      wykonawca_id: "",
      klient_id: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        login: formik.values.login,
        haslo: btoa(formik.values.haslo),
        czy_aktywny: activeValue(formik.values.czy_aktywny),
        aktywny_data_do: (toDate === null || formik.values.czy_aktywny === "false") ? null : toDate,
        operator: operator === null ? null :{
          imie: operator?.imie,
          nazwisko: operator?.nazwisko,
          email: operator?.email,
          telefon: operator?.telefon,
        },
        wykonawca_id: subcontractorId,
        klient_id: null,
      };
      AddUserMutation.mutate(body);
    },
  });


  return ( 
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
    <UserAddContainer>
      <UserAddWrapper onSubmit={formik.handleSubmit}>
        <UserAddForm>
          <FormControl fullWidth>
            <InputLabel id="typ_uzytkownika-label">Typ użytkownika</InputLabel>
            <Select
              placeholder="Typ użytkownika"
              labelId="typ_uzytkownika-label"
              label="Typ użytkownika"
              id="typ_uzytkownika"
              name="typ_uzytkownika"

              value={userType}
              onChange={(e) => {
                setUserType(e.target.value as number);
                if (e.target.value === 0) {
                  setSubcontractorId(null);
                  // setClientId(null);
                  setFormValid(false);
                } else if (e.target.value === 1) {
                  setOperator(null);
                  // setClientId(null);
                  setFormValid(false);
                } else if (e.target.value === 2) {
                  setOperator(null);
                  setSubcontractorId(null);
                  setFormValid(false);
                }
              }}
              // onBlur={formik.handleBlur}
              style={{ backgroundColor: "white" }}
            >
              <MenuItem value={0}>Operator</MenuItem>
              <MenuItem value={1}>Podwykonawca</MenuItem>
              <MenuItem value={2}>Klient</MenuItem>
            </Select>
          </FormControl>
          {
            userType === 2 
            ? 
            <>
              <ClientAddStepper />
            </>
            : 
            null
          }
          {userType !== 2 ? (<>
          <Input
            label="Login"
            id="login"
            name="login"
            value={formik.values.login}
            onChange={formik.handleChange}
            error={formik.touched.login && Boolean(formik.errors.login)}
            helperText={formik.touched.login && formik.errors.login}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          />
          <Input
          label="Hasło"
          id="haslo"
          name="haslo"
          value={formik.values.haslo}
          onChange={formik.handleChange}
          error={formik.touched.haslo && Boolean(formik.errors.haslo)}
          helperText={formik.touched.haslo && formik.errors.haslo}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          />
          <FormLabel id="active-label" style={{textAlign: "center"}}>Aktywny</FormLabel>
          <RadioGroup
            aria-labelledby="active-label"
            defaultValue="true"
            name="czy_aktywny"
            value={formik.values.czy_aktywny}
            onChange={formik.handleChange}
            // error={formik.touched.aktywny && Boolean(formik.errors.aktywny)}
            // helperText={formik.touched.aktywny && formik.errors.aktywny}
            onBlur={formik.handleBlur}
            style={{flexDirection: "row", justifyContent: "space-evenly"}}
          >
            <FormControlLabel value="true" control={<Radio />} label="Aktywny" />
            <FormControlLabel value="false" control={<Radio />} label="Niekatywny" />
          </RadioGroup>
          <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
            <DatePickersWrapper>
              <DesktopDatePicker
                views={["day"]}
                label="Aktywny do"
                disablePast
                disabled = {formik.values.czy_aktywny === "true" ? false : true}
                value={toDate}
                InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
                onError={(error) => setDateToInvalid(error)}
                onChange={(newValue) => {
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <InputWrapper style={{ justifyContent: "flex-start" }}>
                    <Input
                      {...params}
                      helperText={null}
                      variant="filled"
                      sx={{
                        width: "100%",
                        // minWidth: "300px",
                      }}
                    />
                  </InputWrapper>
                )}
              />
            </DatePickersWrapper>
          </LocalizationProvider>
          {userType === 0 ? <OperatorAddForm setOperator={setOperator} setFormValid={setFormValid}/> : null}
          {userType === 1 ? <SubcontractorPick setSubcontractorId={setSubcontractorId} setFormValid={setFormValid}/> : null}
          {/* // {userType === 2 ? <ClientPick setClientId={setClientId} setFormValid={setFormValid}/> : null} */}
          <StyledButton disabled={!formik.isValid || AddUserMutation.isLoading || !formValid || (dateToInvalid === null ? false : true)} type="submit" variant="contained">
            Zapisz
          </StyledButton>
          </>) : null}
        </UserAddForm>
      </UserAddWrapper>
    </UserAddContainer>
    </>
  );
}

export default OperatorUserAdd;

const UserAddContainer = styled.div`
  // height: 80vh;
  width: auto;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;
  // margin-bottom: 150px;

  @media ${theme.device.laptop} {
    margin-left: 320px;
    width: 70%;
    margin-top: 0px;
  }
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  z-index: 10000;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;

const UserAddWrapper = styled.form`
width: 100%;
margin-bottom: 40px;
display: flex;
justify-content: center;
// padding: 0 40px;

@media (${theme.device.laptop}){
  width: 100%;
  // padding: 0 10px;
}
`;

const UserAddForm = styled.div`
width: 90%;
display: flex;
flex-direction: column;
justify-content: center;
min-width:260px;
max-width:420px;
gap: 25px;

@media (${theme.device.laptop}){
  width: 100%;
}
`;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;

const InputWrapper = styled.div`
  width: 100%;
  display: flex;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;
